import { Map, Placemark, YMaps } from "react-yandex-maps";
import React from "react";
import { usePrevious } from "../CustomHook/usePrevious";


const YandexMap = ({ mapTarget, updateMapTarget }) => {
  const geoCord = [43.427616667005616, 39.92669584385667]


  const changeMapTarget = (newTarget) => {
    updateMapTarget(newTarget)
  }

  const prevMapTarget = usePrevious(mapTarget)
  return (<div className="map-wrp">
      {!mapTarget && <div className="map-overlay">Что-бы карта стала активной, введите адрес</div>}

      <YMaps>
        <Map width={"100%"}
             modules={['geocode']}
             state={{
               center: mapTarget ? mapTarget : geoCord, zoom: 17
             }}
             options={{
               restrictMapArea: mapTarget !== prevMapTarget,
             }}
        >
          <Placemark geometry={mapTarget ? mapTarget : geoCord}
                     options={{ draggable: true }}
                     onDragEnd={e => changeMapTarget(e.get('target').geometry.getCoordinates())}
          />
        </Map>
      </YMaps>
    </div>

  )
}

export default YandexMap
